module.exports = __webpack_public_path__ + "static/img/loadingerror.6185fb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/loadingerror.jpg
// module id = rFrP
// module chunks = 80